import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import { getByCurrencyCode } from "../../lib/Currency.ts";
import Icons from "../../svg/Icons.ts";
import * as CustomInput from '../../util/CustomInput.ts';

Html.registerWidget('widget/form/input-amount',{initDom})

function initDom(object: HTMLElement){
  var
    currencyCode = object.getAttribute('data-currency-code'),
    currencyName = getByCurrencyCode(i18n.getShortLanguage(),currencyCode).name,
    initialValue = parseFloat(object.getAttribute('data-value'));

  object.innerHTML = `
<icon data-add="-1" class="rounded" style="border: var(--border);font-size: 30px;box-sizing: content-box;">${Icons.ic_minus}</icon>
<div class="flexauto" style="text-align:center;overflow:visible">
  <input class="flexauto" name="amount" data-currency-display="false" type="amount" data-currency-code="${currencyCode}" style="border:none;text-align:center;color:inherit;font: normal normal bold 40px/47px Roboto;">
  <span style="text-transform:capitalize">${currencyName}</span>
</div>
<icon data-add="1" class="rounded" style="border: var(--border);font-size: 30px;box-sizing: content-box;">${Icons.ic_add_plus}</icon>`;

  var
    input = object.querySelector<HTMLInputElement>('input');
  CustomInput.setAmountValue(input, initialValue);

  object.querySelectorAll<HTMLElement>('icon').forEach(icon => {
    icon.addEventListener('click', function(){
      var
        add = parseInt(icon.getAttribute('data-add')),
        result = CustomInput.getAmountValue(input)+add;
      CustomInput.setAmountValue(input, result);
    });
  });

  input.addEventListener('blur', function(){
    var
      result = CustomInput.getAmountValue(input);
    CustomInput.setAmountValue(input, result);
  });
}